import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../../../utils/testIds/OrderConditions.testIds';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';

interface OrderSplitTreeAllItemProps {
  isSelected: boolean;
  isPressed: boolean;
  isDisabled: boolean;
  onSelect: () => void;
}

const OrderSplitTreeAllItem = ({
  isSelected,
  isPressed,
  isDisabled,
  onSelect,
}: OrderSplitTreeAllItemProps) => {
  const { translate } = useTranslation();

  return (
    <Box
      component="button"
      type="button"
      disabled={isDisabled}
      aria-pressed={isPressed}
      test-id={OrderConditionsTestIds.SPLIT_TREE_ALL}
      onClick={onSelect}
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        padding: 1,
        border: 'none',
        borderRadius: `${theme.shape.borderRadiusMd}px`,
        textAlign: 'left',
        cursor: isDisabled ? 'default' : 'pointer',
        backgroundColor: isSelected ? theme.palette.action.selected : 'transparent',
        '&:hover': {
          backgroundColor: isDisabled ? 'transparent' : theme.palette.action.hover,
        },
      })}
    >
      <Typography
        noWrap
        variant="body2"
        sx={{ color: isDisabled ? 'text.disabled' : 'text.secondary' }}
      >
        {translate(LangEnum.GLOBAL_MALE_ALL)}
      </Typography>
    </Box>
  );
};

export default OrderSplitTreeAllItem;
